// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BlogSliderController from "./blog_slider_controller"
application.register("blog-slider", BlogSliderController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import VideoSliderController from "./video_slider_controller"
application.register("video-slider", VideoSliderController)
